import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    root: {
        padding: 20, 
        width: 300
    },
    wrapTitle: {
        display: 'flex', 
        justifyContent: 'center', 
        marginBottom: 12
    },
    title: {
        fontSize: 16, 
        fontFamily: 'PT-sans, sans-serif'
    },
    wrapInput: {
        display: 'flex', 
        flexDirection: 'column'
    },
    input: {
        border: '1px solid #e5e5e5', 
        borderRadius: 4, 
        padding: 10   
    },
    wrapBtn: {
        width: '100%', 
        display: 'flex', 
        marginTop: 12
    },
    btn: {
        padding: '7px 10px', 
        background: '#ebc015', 
        borderRadius: 8, 
        color: 'rgb(27, 32, 57)',
        width: '100%',
        textAlign: 'center'
    }
}))

export {
    useStyles
}